module.exports = __webpack_public_path__ + "media/17_Long.fac67b25.mp3";